import { NgClass, NgTemplateOutlet } from '@angular/common';

import {
  AfterViewInit,
  Component,
  ElementRef,
  input,
  output,
  signal,
  viewChild,
} from '@angular/core';
import { BadgeComponent } from '@shared/ui/badge';

export type ButtonModeType =
  | 'primary'
  | 'outline'
  | 'light'
  | 'green'
  | 'link'
  | 'soft'
  | 'filled';
export type ButtonFormType = 'square' | 'circle';
export type ButtonSizeType = 'small' | 'normal' | 'medium' | 'stretch';
export type ButtonUtilityType = 'none' | 'dropdown';
export type ButtonAdaptiveType =
  | 'none'
  | 'stretch'
  | 'text-icon'
  | 'text-with-icon-icon';

/**
 * @deprecated Reimplement this component
 */
@Component({
  selector: 'shared-ui-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css'],
  imports: [NgClass, NgTemplateOutlet, BadgeComponent],
})
export class ButtonComponent implements AfterViewInit {
  buttonElement = viewChild<ElementRef>('buttonElement');

  contentElement = viewChild<ElementRef>('contentElement');

  mode = input<ButtonModeType>('primary');

  form = input<ButtonFormType | undefined>();

  size = input<ButtonSizeType>('normal');

  utility = input<ButtonUtilityType | undefined>('none');

  adaptive = input<ButtonAdaptiveType | undefined>('none');

  icon = input<string>();

  iconColor = input<string>();

  numberBadge = input<number>();

  iconSize = input<number>();

  filled = input(false);

  disabled = input<boolean | null>(null);

  tabindex = input(0);

  focus = input(false);

  testId = input<string | undefined>(undefined);

  buttonClass = input<string>();

  href = input<string>();

  hasContent = signal(false);

  clicked = output<MouseEvent>();

  ngAfterViewInit(): void {
    if (this.focus()) {
      this.buttonElement()?.nativeElement.focus();
    }
    this.hasContent.set(this.contentElement()?.nativeElement.hasChildNodes());
  }

  onClick($event: MouseEvent): void {
    if (this.disabled()) {
      //  $event.stopPropagation();
      return;
    }

    this.buttonElement()?.nativeElement.blur();
    if (!this.href()) {
      this.clicked.emit($event);
    }
  }

  onLinkClick($event: MouseEvent): void {
    if (this.disabled()) {
      $event.preventDefault();
    }
  }
}
